const local_scopes = {
    LOCAL_GET : 'local:local:get', // '/local/id'
    LOCAL_LIST : 'local:local:list', // '/locals'
};

export default local_scopes;
